// extracted by mini-css-extract-plugin
export default {"link":"cR6Tb"};